import * as constants from './constants';
import {get, testRequest} from '../../../utils/request';

import {INDEX_API} from '../../../utils/api';

const indexList = (DataList) => ({
    type: constants.INDEX_LIST,
    value: DataList
});

export const getIndexList = () => {
    return (dispatch) => {
        return get(INDEX_API, {})
            .then((response) => {
                dispatch(indexList(response.data));
            })
    }
}

